import { GeneralModel } from "./general.model";

export class Report extends GeneralModel {}



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/report.model.ts